import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CommonLoaderFormBtn from "src/common/CommonLoaderFormBtn";
import { useApiMutation } from "src/hooks/useApiMutation";

interface IProps {
	handleClose?: Function;
	showModal: {
		showModal: boolean;
		id: string | number;
	};
}

const SpecificStallUpdate = ({ handleClose, showModal }: IProps) => {
	const { register, handleSubmit, reset } = useForm();
	const [status, setStatus] = useState<string>("");
	const { mutate, isPending, isSuccess } = useApiMutation({
		endPoint: `/api/fair/stall-exhibitor/${showModal?.id}`,
		method: "PATCH",
		invalidateQueries: ["exhibitorDetails", "SingleStall"],
	});
	const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value) {
			setStatus(e.target.value);
		}
	};

	const onSubmit = async (inputs) => {
		await mutate(inputs);
	};

	useEffect(() => {
		if (isSuccess) {
			reset();
			handleClose();
		}
	}, [isSuccess]);

	return (
		<Box
			component='form'
			onSubmit={handleSubmit(onSubmit)}
			sx={{
				mt: 1,
			}}
		>
			<Grid item xs={12}>
				<FormControl required fullWidth>
					<InputLabel required id='demo-simple-select-label'>
						Stall Status
					</InputLabel>
					<Select
						{...register("status")}
						id='outlined-required'
						value={status}
						label='Invoice status'
						required
						onChange={handleStatusChange}
					>
						<MenuItem value='approved'>Approved</MenuItem>
						<MenuItem value='pending'>Pending</MenuItem>
						<MenuItem value='rejected'>Rejected</MenuItem>
					</Select>
				</FormControl>
			</Grid>

			<CommonLoaderFormBtn loading={isPending} btnText='Update' />
		</Box>
	);
};

export default SpecificStallUpdate;
